import _ from 'lodash';

export const removeDuplicates = array => (
  _.uniqWith(array, _.isEqual)
);

export const removeEmpty = array => (
  _.filter(array, (o) => {
    if (o === '' || o === null || o === undefined || (typeof o === 'object' && _.isEmpty(o))) {
      return false;
    }
    return true;
  })
);

export const mapRecentlyUsedValues = (array, key) => {
  const filteredArray = array.filter((obj) => {
    const value = obj[key];
    return (!!value || value === 0);
  });
  const values = filteredArray.map(obj => obj[key]);
  return values;
};



// WEBPACK FOOTER //
// ./src/utility/recentlyUsed.js